module.exports = __webpack_public_path__ + "img/danger.60426361.svg";